import { render, staticRenderFns } from "./mgcmanage_expand.vue?vue&type=template&id=a239a884&scoped=true"
import script from "./mgcmanage_expand.vue?vue&type=script&lang=js"
export * from "./mgcmanage_expand.vue?vue&type=script&lang=js"
import style0 from "./mgcmanage_expand.vue?vue&type=style&index=0&id=a239a884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a239a884",
  null
  
)

export default component.exports